// /* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import { getProjectConfig, getServerTime, getTicketList } from '@/api'
import { getList } from '@/api/shoppingcart'
// import { getSearchParamByName } from '@/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    cartLoading: false,
    ticketInfo: {},
    cartItems: [],
    showMember: false,
    projectConfig: {
      app_pc_pay_way: [],
      buyer_need_realname: false,
      player_need_realname: false
    }
  },
  getters: {
    cartNum (state) {
      return state.cartItems.length
    }
  },
  mutations: {
    SET_SHOW_MEMBER (state, val) {
      state.showMember = val
    },
    setUsername (state, payload) {
      state.username = payload
    },
    setTicketInfo (state, payload) {
      state.ticketInfo = payload
    },
    SET_PROJECT_CONFIG (state, data) {
      state.projectConfig = data
    },
    SET_TIME_DIFF (state, data) {
      state.timeDiff = data
    },
    SET_CART_ITEMS (state, data) {
      state.cartItems = data
    },
    ADD_CART (state, data) {
      state.cartItems.push(data)
      console.log(state.cartItems)
    },
    REMOVE_CART (state, index) {
      state.cartItems.splice(index, 1)
    },
    SET_CART_LOADING (state, data) {
      state.cartLoading = data
    }
  },
  actions: {
    getCartItems ({ commit }) {
      commit('SET_CART_LOADING', true)
      getList().then(res => {
        console.log(res.list)
        commit('SET_CART_ITEMS', res)
      }).finally(() => {
        commit('SET_CART_LOADING', false)
      })
    },
    getProjectConfig ({ commit }) {
      // const project = getSearchParamByName('project') || ''
      function isJson (str) {
        if (typeof str === 'string') {
          try {
            var obj = JSON.parse(str)
            if (typeof obj === 'object' && obj) {
              return true
            } else {
              return false
            }
          } catch (e) {
            console.log('error：' + str + '!!!' + e)
            return false
          }
        } else {
          return false
        }
      }

      getProjectConfig().then(res => {
        if (isJson(res.data.extraInfo.app_background)) {
          const bg = JSON.parse(res.data.extraInfo.app_background)

          document.body.style.backgroundImage = `url(${bg.backgroundImage})`
          document.body.style.backgroundColor = bg.backgroundColor
        }

        document.title = res.data.extraInfo.app_title + ' - 购买门票'
        commit('SET_PROJECT_CONFIG', res.data.extraInfo)
      })

      getTicketList({
        type: 'MEMBER',
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        commit('SET_SHOW_MEMBER', res.data.extraInfo.total > 0)
      })
    },
    setTimeDiff ({ commit, state }) {
      if (state.timeDiff > 0) return

      return getServerTime().then(res => {
        const serverTime = res.data.extraInfo.current_time

        console.log(moment(serverTime).format('YYYY-MM-DD HH:mm:ss'))

        commit('SET_TIME_DIFF', moment(serverTime).diff(new Date()))
      })
    }
  }
})
